import React from 'react';
import {
  VStack,
  Heading,
  Text,
  Button,
  Card,
  CardBody,
  SimpleGrid,
  useColorModeValue,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

const CreatePage = () => {
  const cardBg = useColorModeValue('white', 'gray.800');

  return (
    <VStack spacing={6} align="stretch">
      <Heading size="xl" color="gray.700">
        ➕ Create Content
      </Heading>

      <Text fontSize="lg" color="gray.600" textAlign="center">
        Choose what you want to create from the options below
      </Text>

      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
        <Card bg={cardBg} shadow="md" _hover={{ shadow: 'lg', transform: 'translateY(-2px)' }} transition="all 0.2s">
          <CardBody textAlign="center">
            <VStack spacing={4}>
              <Text fontSize="4xl">📚</Text>
              <Heading size="md">Create Series</Heading>
              <Text fontSize="sm" color="gray.600">
                Start a new educational series
              </Text>
              <Button as={RouterLink} to="/series" colorScheme="blue" w="full">
                Create Series
              </Button>
            </VStack>
          </CardBody>
        </Card>

        <Card bg={cardBg} shadow="md" _hover={{ shadow: 'lg', transform: 'translateY(-2px)' }} transition="all 0.2s">
          <CardBody textAlign="center">
            <VStack spacing={4}>
              <Text fontSize="4xl">📝</Text>
              <Heading size="md">Create Subject</Heading>
              <Text fontSize="sm" color="gray.600">
                Add a subject to a series
              </Text>
              <Button as={RouterLink} to="/subjects" colorScheme="green" w="full">
                Create Subject
              </Button>
            </VStack>
          </CardBody>
        </Card>

        <Card bg={cardBg} shadow="md" _hover={{ shadow: 'lg', transform: 'translateY(-2px)' }} transition="all 0.2s">
          <CardBody textAlign="center">
            <VStack spacing={4}>
              <Text fontSize="4xl">🎓</Text>
              <Heading size="md">Create Class</Heading>
              <Text fontSize="sm" color="gray.600">
                Add a class to a subject
              </Text>
              <Button as={RouterLink} to="/classes" colorScheme="purple" w="full">
                Create Class
              </Button>
            </VStack>
          </CardBody>
        </Card>

        <Card bg={cardBg} shadow="md" _hover={{ shadow: 'lg', transform: 'translateY(-2px)' }} transition="all 0.2s">
          <CardBody textAlign="center">
            <VStack spacing={4}>
              <Text fontSize="4xl">📕</Text>
              <Heading size="md">Create Book</Heading>
              <Text fontSize="sm" color="gray.600">
                Add a book to a class
              </Text>
              <Button as={RouterLink} to="/books" colorScheme="orange" w="full">
                Create Book
              </Button>
            </VStack>
          </CardBody>
        </Card>

        <Card bg={cardBg} shadow="md" _hover={{ shadow: 'lg', transform: 'translateY(-2px)' }} transition="all 0.2s">
          <CardBody textAlign="center">
            <VStack spacing={4}>
              <Text fontSize="4xl">📁</Text>
              <Heading size="md">Create Book Type</Heading>
              <Text fontSize="sm" color="gray.600">
                Define file types (PDF, eBook, etc.)
              </Text>
              <Button as={RouterLink} to="/book-types" colorScheme="teal" w="full">
                Create Book Type
              </Button>
            </VStack>
          </CardBody>
        </Card>

        <Card bg={cardBg} shadow="md" _hover={{ shadow: 'lg', transform: 'translateY(-2px)' }} transition="all 0.2s">
          <CardBody textAlign="center">
            <VStack spacing={4}>
              <Text fontSize="4xl">⬆️</Text>
              <Heading size="md">Upload Files</Heading>
              <Text fontSize="sm" color="gray.600">
                Upload book files or add links
              </Text>
              <Button as={RouterLink} to="/files" colorScheme="cyan" w="full">
                Upload Files
              </Button>
            </VStack>
          </CardBody>
        </Card>
      </SimpleGrid>

      <Card bg={cardBg} shadow="md" mt={6}>
        <CardBody>
          <VStack spacing={3}>
            <Heading size="md" color="gray.700">
              Quick Start Guide
            </Heading>
            <Text textAlign="center" color="gray.600">
              1. Create a <strong>Series</strong> first (e.g., "Mathematics") → 
              2. Add <strong>Subjects</strong> (e.g., "Algebra") → 
              3. Create <strong>Classes</strong> (e.g., "Grade 9") → 
              4. Add <strong>Books</strong> → 
              5. Define <strong>Book Types</strong> → 
              6. <strong>Upload Files</strong>
            </Text>
          </VStack>
        </CardBody>
      </Card>
    </VStack>
  );
};

export default CreatePage; 